{
  "longPressMessage": "길게 눌러 미리 보기 열기"
}
